import { render, staticRenderFns } from "./presentRelationship.vue?vue&type=template&id=3b4eab70"
import script from "./presentRelationship.vue?vue&type=script&lang=js"
export * from "./presentRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports